<!-- Bouton Retour Coordonnées -->
<dsd-link-action variant="return">
  <a [href]="urlCoordonnees"
    ><span class="dsd-sr-only">{{ 'bouton.horsEcran.allerA' | translate }}&nbsp;</span
    >{{ 'bouton.coordonnees' | translate }}</a
  >
</dsd-link-action>
